import { hasPushPermissions } from 'dashboard/helper/pushHelper';
import DashboardAudioNotificationHelper from 'dashboard/helper/AudioAlerts/DashboardAudioNotificationHelper';

// Whether a running threshold's elapsed-time progress (0-1) has reached the user's
// configured alert percentage (1-99, stored as a whole number in ui_settings).
export const hasReachedAlertPercentage = (progress, percentage) => {
  if (!percentage || progress == null) return false;
  return progress >= percentage / 100;
};

// `CustomSlaBadge.vue` mounts once per conversation-list card AND once more for the
// currently open conversation's header — two independent component instances ticking the
// same conversation's countdown at once. Tracking "already alerted" as module-level state
// (shared across every instance) rather than per-component state is what keeps a single
// window from firing the alert twice, once from each instance.
const alertedWindows = new Set();

export const shouldAlertOnce = windowKey => {
  if (alertedWindows.has(windowKey)) return false;
  alertedWindows.add(windowKey);
  return true;
};

// Reuses the same tone/Audio element the user already picked for message alerts
// (initialized at app boot regardless of whether message audio alerts are on) rather
// than introducing a second, redundant tone selection just for SLA alerts.
export const playCustomSlaAlertSound = () => {
  DashboardAudioNotificationHelper.playAudioAlert();
};

// A plain desktop `Notification`, not a full VAPID push subscription — this only needs
// to work while the dashboard tab is open (see design.md), so there is no backend round
// trip, just the browser permission already requested via the profile settings toggle.
// `tag` de-duplicates repeated OS-level notifications for the same threshold instance
// (the browser replaces rather than stacks notifications sharing a tag).
export const showCustomSlaDesktopNotification = ({ title, body, tag, url }) => {
  if (!hasPushPermissions()) return;

  const notification = new Notification(title, { body, tag });
  if (url) {
    notification.onclick = () => {
      window.focus();
      window.location.href = url;
    };
  }
};
